import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-69ddb4b4")

_pushScopeId("data-v-69ddb4b4")
const _hoisted_1 = { class: "full_container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "logo_container" }, [
  /*#__PURE__*/_createVNode("img", { src: "assets/logo.png" })
], -1)
const _hoisted_3 = { class: "form_container ion-padding-horizontal" }
const _hoisted_4 = { class: "email_input" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Email", -1)
const _hoisted_6 = { class: "password_input" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Password", -1)
const _hoisted_8 = { class: "ricordami_input" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Ricordami", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("button", {
  size: "default",
  type: "submit",
  class: "btn_login"
}, " Login ", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Come installare l'applicazione ")
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "logo_ingegno" }, [
  /*#__PURE__*/_createVNode("img", { src: "assets/logo_ingegno.png" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_loading = _resolveComponent("ion-loading")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, null, {
              default: _withId(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, { class: "ion-padding" }, {
                      default: _withId(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode("form", {
                  onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.doLogin()), ["prevent"]))
                }, [
                  _createVNode(_component_ion_row, null, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_3, [
                        _createVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _createVNode(_component_ion_input, {
                            type: "email",
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                            placeholder: "La tua email",
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_6, [
                          _hoisted_7,
                          _createVNode(_component_ion_input, {
                            type: "password",
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
                            placeholder: "La tua password",
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createVNode(_component_ion_checkbox, {
                            class: "ion-margin-end",
                            modelValue: _ctx.ricordami,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.ricordami = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col, { class: "ion-padding" }, {
                        default: _withId(() => [
                          _hoisted_10,
                          _createVNode(_component_ion_button, {
                            color: "secondary",
                            fill: "clear",
                            size: "small",
                            expand: "full",
                            onClick: _ctx.openModal,
                            class: "btn_helper"
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 32),
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withId(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_ion_loading, {
            "is-open": _ctx.loading,
            message: "Autenticazione in corso",
            duration: 5000,
            onDidDismiss: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setOpen(false)))
          }, null, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})